import React from "react";
import { useNavigate } from "react-router-dom";
import { motion } from "framer-motion";
import { ShieldCheck, Lock, Mail, Loader2 } from "lucide-react";
import { useAuth } from "@/context/AuthContext";

export default function AdminLogin() {
  const { login, user } = useAuth();
  const navigate = useNavigate();
  const [email, setEmail] = React.useState("");
  const [password, setPassword] = React.useState("");
  const [error, setError] = React.useState("");
  const [busy, setBusy] = React.useState(false);

  React.useEffect(() => { if (user) navigate("/admin"); }, [user, navigate]);

  const submit = async (e) => {
    e.preventDefault();
    setError(""); setBusy(true);
    const res = await login(email, password);
    setBusy(false);
    if (res.ok) navigate("/admin");
    else setError(res.error);
  };

  return (
    <div className="min-h-screen flex items-center justify-center bg-gray-50 px-4">
      <div className="absolute -top-32 -right-24 w-[30rem] h-[30rem] rounded-full blur-3xl pointer-events-none" style={{ background: "rgba(234,106,10,0.10)" }} />
      <motion.div initial={{ opacity: 0, y: 24 }} animate={{ opacity: 1, y: 0 }} transition={{ duration: 0.5 }}
        className="relative w-full max-w-md bg-white rounded-3xl border border-gray-100 shadow-[0_20px_50px_rgba(0,0,0,0.08)] p-8 sm:p-10">
        <div className="flex items-center gap-2.5 mb-8">
          <span className="flex items-center justify-center w-10 h-10 rounded-xl bg-[#EA6A0A] text-white"><ShieldCheck size={22} /></span>
          <div>
            <p className="font-display font-800 text-lg tracking-tight text-[#EA6A0A] leading-none">Rischio Zero</p>
            <p className="text-xs text-gray-400 mt-1">Pannello Amministratore</p>
          </div>
        </div>

        <h1 className="font-display font-800 text-2xl tracking-tight text-gray-900">Accedi</h1>
        <p className="text-sm text-gray-500 mt-1">Inserisci le tue credenziali per gestire il sito.</p>

        <form onSubmit={submit} className="mt-7 space-y-4">
          <div>
            <label className="text-xs font-600 text-gray-500 uppercase tracking-wide">Email</label>
            <div className="relative mt-1.5">
              <Mail size={16} className="absolute left-3.5 top-1/2 -translate-y-1/2 text-gray-400" />
              <input data-testid="login-email" type="email" required value={email} onChange={(e) => setEmail(e.target.value)}
                className="w-full pl-10 pr-4 py-3 rounded-xl border border-gray-200 focus:outline-none focus:ring-2 focus:ring-[#EA6A0A]/20 focus:border-[#EA6A0A] transition-all"
                placeholder="admin@rischio-zero.it" />
            </div>
          </div>
          <div>
            <label className="text-xs font-600 text-gray-500 uppercase tracking-wide">Password</label>
            <div className="relative mt-1.5">
              <Lock size={16} className="absolute left-3.5 top-1/2 -translate-y-1/2 text-gray-400" />
              <input data-testid="login-password" type="password" required value={password} onChange={(e) => setPassword(e.target.value)}
                className="w-full pl-10 pr-4 py-3 rounded-xl border border-gray-200 focus:outline-none focus:ring-2 focus:ring-[#EA6A0A]/20 focus:border-[#EA6A0A] transition-all"
                placeholder="••••••••" />
            </div>
          </div>

          {error && <p data-testid="login-error" className="text-sm text-[#EF4444] bg-red-50 rounded-lg px-3 py-2">{error}</p>}

          <button data-testid="login-submit" type="submit" disabled={busy}
            className="w-full inline-flex items-center justify-center gap-2 py-3.5 rounded-full bg-[#EA6A0A] text-white font-600 shadow-[0_8px_24px_-6px_rgba(234,106,10,0.5)] hover:bg-[#C8590A] transition-all disabled:opacity-60">
            {busy ? <Loader2 size={18} className="animate-spin" /> : <Lock size={16} />}
            {busy ? "Accesso..." : "Accedi"}
          </button>
        </form>
        <a href="/" className="block text-center text-sm text-gray-400 mt-6 hover:text-gray-600">← Torna al sito</a>
      </motion.div>
    </div>
  );
}
